import React from 'react';
import { motion } from 'framer-motion';
const fade = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function HeroSection() {
  return <section className="relative w-full h-screen overflow-hidden bg-primary" data-id="element-93" data-mp="23xed4gez5d7x">
      {/* Full-bleed render — the image leads */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.08
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1]
    }} className="absolute inset-0" data-id="element-94" data-mp="2wj76y0ialhik">
        <img src="https://cdn.magicpatterns.com/uploads/o4UGbA4urx3abHHuALaY2Q/WhatsApp_Image_2026-10-03_at_16.17.39_(1).jpg" alt="Upper-level living space at 35 Campanilla with timber spiral staircase and floor-to-ceiling garden views" className="w-full h-full object-cover" data-id="element-95" data-mp="2rsh3istffoqi" />
      </motion.div>

      {/* Soft scrim only where text sits, so the image stays dominant */}
      <div className="absolute inset-0 bg-black/45 pointer-events-none" data-id="element-96" data-mp="2beyesq12s43w" />

      {/* Centered title + intro */}
      <div className="absolute inset-0 z-10 flex items-center justify-center px-6 md:px-14" data-id="element-97" data-mp="2p63ka8r4jqm5">
        <motion.div initial="hidden" animate="visible" variants={fade} className="max-w-2xl mx-auto text-center" data-id="element-98" data-mp="2kdk2t0pbgbc2">
          <h1 className="font-heading text-white font-light leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-7xl" data-id="element-99" data-mp="2u4ojc4un4490">
            Your future home awaits.
          </h1>
          <p className="mt-5 md:mt-6 text-base md:text-xl font-light leading-relaxed text-white/85" data-id="element-100" data-mp="381tn1y6vsr13">
            Campanilla is a 610 sqm residence in Ayala Westgrove Heights, with
            generous, light-filled rooms, a timeless architectural language,
            and a layout planned around the way you actually live.
          </p>
        </motion.div>
      </div>

      {/* Scroll Indicator — centered so it never overlaps the caption text */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-101" data-mp="3dth5hhlp8bat">
        <div className="w-[1px] h-12 bg-white/20 overflow-hidden" data-id="element-102" data-mp="3rr5n8gkgz2bn">
          <motion.div animate={{
          y: ['-100%', '100%']
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} className="w-full h-full bg-white" data-id="element-103" data-mp="lmcpgu7993q" />
        </div>
      </motion.div>
    </section>;
}